import React, { ReactElement, useEffect, useState } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { Link, resolvePath, Route, Routes, useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { etatUtilisateurConnecte } from '../../State';
import NotFound from '../NotFound';
import Activites from './Activites/Activites';
import CreerActivite from './Activites/CreerActivite';
import DetailsActivite from './Activites/DetailsActivite';
import ListeClients from './Clients/Clients';
import DetailsClient from './Clients/DetailsClient';
import ListeContacts from './Contacts/Contacts';
import CreerContact from './Contacts/CreerContact';
import DetailsContact from './Contacts/DetailsContact';
import CreerFournisseur from './Fournisseurs/CreerFournisseur';
import DetailsFournisseur from './Fournisseurs/DetailsFournisseur';
import ListeFournisseurs from './Fournisseurs/Fournisseurs';
import CreerProduit from './Produits/CreerProduit';
import DetailsProduit from './Produits/DetailsProduit';
import CreerLieu from './Lieux/CreerLieu';
import DetailsLieu from './Lieux/DetailsLieu';
import Lieux from './Lieux/Lieux';
import CentreServiceScolaire from './Css/CentreServiceScolaire';
import CreerCentreServiceScolaire from './Css/CreerCentreServiceScolaire';
import DetailsCentreServiceScolaire from './Css/DetailsCentreServiceScolaire';
import CalendrierScolaire from './CalendrierScolaire/CalendrierScolaire';
import CreerCalendrierScolaire from './CalendrierScolaire/CreerCalendrierScolaire';
import DetailsCalendrierScolaire from './CalendrierScolaire/DetailsCalendrierScolaire';
import DashboardNavbar from './Navbar';
import Sidebar from './Sidebar';
import CreerClient from './Clients/CreerClient';
import Options from './Options/Options';
import { Navigate } from 'react-router';
import { setQueryStringValue } from '../../Utils/queryString';
import { BiErrorAlt } from 'react-icons/all';
import Erreurs from './Erreurs/Erreurs';
import PageRecherche from './PageRecherche/PageRecherche';
import Etiquette from './Etiquettes/Etiquettes';
import CreerCategorie from './Etiquettes/CreerModifierCategorie';
import Produits from './Produits/Produits';
import Ententes from './Ententes/Ententes';
import CreerEntente from './Ententes/CreerEntente';
import DetailsEntente from './Ententes/DetailsEntente';
import Logs from './HistoriqueLog/Logs';
import LoadingScreen from '../Common/LoadingScreen';
import MenuEntentes from './Ententes/MenuEntente';
import ModelesHoraire from './ModelesHoraire/ModelesHoraire';
import DetailsModeleHoraire from './ModelesHoraire/DetailsModeleHoraire';
import CreerModeleHoraire from './ModelesHoraire/CreerModeleHoraire';
import AfficherEntentePDF from './Ententes/PDF/AfficherEntentePDF';
import ModelesCourriel from './ModelesCourriel/ModelesCourriel';
import DetailsModeleCourriel from './ModelesCourriel/DetailsModeleCourriel';
import CreerModeleCourriel from './ModelesCourriel/CreerModeleCourriel';

export default function Dashboard(): ReactElement {
    const [utilisateurConnecte] = useRecoilState(etatUtilisateurConnecte);
    const location = useLocation();

    const [affichageActivitePublic, setAffichageActivitePublic] = useState<boolean>(
        localStorage.getItem('modePublic') === 'true',
    );

    useEffect(() => {
        localStorage.setItem('modePublic', `${affichageActivitePublic}`);
    }, [affichageActivitePublic]);

    return (
        <div className="dashboard">
            {typeof utilisateurConnecte.connecte === 'undefined' ? (
                <LoadingScreen></LoadingScreen>
            ) : utilisateurConnecte.connecte ? (
                utilisateurConnecte.admin ? (
                    <IconContext.Provider value={{ size: '1.25em' }}>
                        <Sidebar>
                            <DashboardNavbar
                                affichageActivitePublic={affichageActivitePublic}
                                setAffichageActivitePublic={setAffichageActivitePublic}
                            />
                            <Container fluid className="pt-3">
                                <Routes>
                                    <Route path="/" element={<Navigate to="ententes" />} />
                                    <Route
                                        path="activites/*"
                                        element={
                                            <Routes>
                                                <Route path="/" element={<Activites mode={false} />} />
                                                <Route path=":id" element={<DetailsActivite />} />
                                                <Route path="new" element={<CreerActivite />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="fournisseurs/*"
                                        element={
                                            <Routes>
                                                <Route path=":id" element={<DetailsFournisseur />} />
                                                <Route path="new" element={<CreerFournisseur />} />
                                                <Route path="/" element={<ListeFournisseurs />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="produits/*"
                                        element={
                                            <Routes>
                                                <Route path=":id" element={<DetailsProduit />} />
                                                <Route path="new" element={<CreerProduit />} />
                                                <Route path="/" element={<Produits />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="ententes/*"
                                        element={
                                            <Routes>
                                                {/* <Route path="/" element={<div>TODO</div>} /> */}
                                                <Route path="/" element={<Ententes />} />
                                                {/* https://trello.com/c/UUQye0ir/787-bug-liste-des-ententes-en-prod-seulement */}
                                                <Route path="new" element={<CreerEntente />} />
                                                <Route path=":id" element={<DetailsEntente />} />
                                                <Route path=":id/menu" element={<MenuEntentes />} />
                                                <Route path=":id/doc/:type" element={<AfficherEntentePDF />} />
                                            </Routes>
                                        }
                                    />

                                    <Route
                                        path="modeles-horaire/*"
                                        element={
                                            <Routes>
                                                <Route path="/" element={<ModelesHoraire />} />
                                                <Route path="new" element={<CreerModeleHoraire />} />
                                                <Route path=":id" element={<DetailsModeleHoraire />} />
                                            </Routes>
                                        }
                                    />

                                    <Route
                                        path="logs/*"
                                        element={
                                            <Routes>
                                                <Route path="/" element={<Logs />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="contacts/*"
                                        element={
                                            <Routes>
                                                <Route path=":id" element={<DetailsContact />} />
                                                <Route path="new" element={<CreerContact />} />
                                                <Route path="/" element={<ListeContacts />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="clients/*"
                                        element={
                                            <Routes>
                                                <Route path=":id" element={<DetailsClient />} />
                                                <Route path="new" element={<CreerClient />} />
                                                <Route path="/" element={<ListeClients />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="centres-service-scolaire/*"
                                        element={
                                            <Routes>
                                                <Route path="new" element={<CreerCentreServiceScolaire />} />
                                                <Route path=":id" element={<DetailsCentreServiceScolaire />} />
                                                <Route path="/" element={<CentreServiceScolaire />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="lieux/*"
                                        element={
                                            <Routes>
                                                <Route path="new" element={<CreerLieu />} />
                                                <Route path=":id" element={<DetailsLieu />} />
                                                <Route path="/" element={<Lieux />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="calendrier-scolaire/*"
                                        element={
                                            <Routes>
                                                <Route path="new" element={<CreerCalendrierScolaire />} />
                                                <Route path=":id" element={<DetailsCalendrierScolaire />} />
                                                <Route path="/" element={<CalendrierScolaire />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="etiquettes/*"
                                        element={
                                            <Routes>
                                                <Route path="/" element={<Etiquette />} />
                                                <Route path="new" element={<CreerCategorie />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="options/*"
                                        element={
                                            <Routes>
                                                <Route path="/" element={<Options />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="erreurs/*"
                                        element={
                                            <Routes>
                                                <Route path="/" element={<Erreurs />} />
                                            </Routes>
                                        }
                                    />
                                    <Route
                                        path="modeles-courriel/*"
                                        element={
                                            <Routes>
                                                <Route path=":id" element={<DetailsModeleCourriel />} />
                                                <Route path="new" element={<CreerModeleCourriel />} />
                                                <Route path="/" element={<ModelesCourriel />} />
                                            </Routes>
                                        }
                                    />
                                    <Route path="/recherche" element={<PageRecherche />} />
                                    <Route path="*" element={<NotFound />} />
                                </Routes>
                            </Container>
                        </Sidebar>
                    </IconContext.Provider>
                ) : (
                    <Alert variant="danger" className="h4 m-5 p-4 d-flex align-items-center">
                        <BiErrorAlt size="1.25em" />
                        &nbsp;
                        <strong>Accès interdit!</strong>&nbsp;
                        <Link to="/">Retour à l&apos;accueil</Link>
                    </Alert>
                )
            ) : (
                <Navigate to={setQueryStringValue('next', location.pathname, resolvePath('/login'))} />
            )}
        </div>
    );
}
